import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const locations = [
  {
    id: 'w-3rd-street',
    name: 'Greenly Electronics Recycling — W 3rd Street',
    address: '2542 W. 3rd Street',
    city: 'Los Angeles',
    state: 'CA',
    zip: '90057',
    neighborhood: 'Westlake / MacArthur Park',
    phone: '(213) 600-1000',
    tel: '+12136001000',
    email: 'info@greenly.us',
    hours: [
      { days: 'Monday – Friday', time: '8:00 AM – 5:00 PM' },
      { days: 'Saturday', time: '9:00 AM – 2:00 PM' },
      { days: 'Sunday', time: 'Closed' },
    ],
    mapEmbed: 'https://maps.google.com/maps?q=Greenly+Electronics+Recycling+%26+Data+Destruction,+2542+W+3rd+St,+Los+Angeles,+CA+90057&output=embed&z=16',
    mapLink: 'https://maps.app.goo.gl/1GFb4ZnoPCREHhzy6',
    nearbyAreas: ['Downtown LA', 'Koreatown', 'Silver Lake', 'Echo Park', 'MacArthur Park', 'Mid-City'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20electronics%20recycling%20drop-off%20facility%20entrance%20in%20Los%20Angeles%20urban%20neighborhood%20on%20W%203rd%20Street%2C%20clean%20professional%20building%20exterior%20with%20green%20eco%20branding%20signage%2C%20welcoming%20drop-off%20area%2C%20bright%20sunny%20day%20Los%20Angeles%20California%20street&width=700&height=420&seq=loc001&orientation=landscape',
  },
  {
    id: 'w-slauson-ave',
    name: 'Greenly Electronics Recycling — W Slauson Ave',
    address: '4902 W. Slauson Ave',
    city: 'Los Angeles',
    state: 'CA',
    zip: '90056',
    neighborhood: 'Ladera Heights / Baldwin Hills',
    phone: '(213) 600-1000',
    tel: '+12136001000',
    email: 'info@greenly.us',
    hours: [
      { days: 'Monday – Friday', time: '8:00 AM – 5:00 PM' },
      { days: 'Saturday', time: '9:00 AM – 2:00 PM' },
      { days: 'Sunday', time: 'Closed' },
    ],
    mapEmbed: 'https://maps.google.com/maps?q=4902+W+Slauson+Ave,+Los+Angeles,+CA+90056&output=embed&z=16',
    mapLink: 'https://maps.google.com/?q=4902+W+Slauson+Ave+Los+Angeles+CA+90056',
    nearbyAreas: ['Ladera Heights', 'Baldwin Hills', 'Inglewood', 'Culver City', 'Crenshaw', 'View Park'],
    image: '/images/Location-2.jpg',
  },
];

const services = [
  { icon: 'ri-computer-line', label: 'Computer Recycling', path: '/computer-recycling' },
  { icon: 'ri-tv-line', label: 'TV Recycling', path: '/tv-recycling' },
  { icon: 'ri-battery-charge-line', label: 'Battery Recycling', path: '/battery-recycling' },
  { icon: 'ri-hard-drive-line', label: 'Hard Drive Destruction', path: '/hard-drive-destruction' },
  { icon: 'ri-recycle-line', label: 'All Electronics', path: '/services' },
];

const LocationsPage = () => (
  <>
    <title>Electronics Recycling Drop-Off Locations in Los Angeles | Greenly</title>
    <meta name="description" content="2 free electronics recycling drop-off locations in Los Angeles. 2542 W. 3rd St (90057) & 4902 W. Slauson Ave (90056). TVs, computers, batteries accepted. Open Mon–Sat. No appointment needed." />
    <meta name="keywords" content="electronics recycling locations Los Angeles, e-waste drop off Los Angeles, recycling center Los Angeles, Greenly locations LA" />
    <meta name="robots" content="index, follow" />
    <meta name="last-modified" content="2026-05-11" />
    <link rel="canonical" href={`${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/locations`} />
    {/* Per-location Schema.org */}
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/locations#webpage`,
          "url": `${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/locations`,
          "name": "Electronics Recycling Drop-Off Locations in Los Angeles | Greenly",
          "description": "2 electronics recycling drop-off locations in Los Angeles. 2542 W. 3rd Street (90057) & 4902 W. Slauson Ave (90056). Accept TV, computer, battery recycling. Open Mon–Sat. No appointment needed.",
          "isPartOf": { "@id": `${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/#website` },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": `${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/` },
              { "@type": "ListItem", "position": 2, "name": "Drop-Off Locations", "item": `${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/locations` }
            ]
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Greenly Electronics Recycling — W 3rd Street",
          "description": "Electronics recycling drop-off in Los Angeles. TV recycling, computer recycling, battery recycling, hard drive destruction. CalRecycle CEWD-127531.",
          "url": `${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/locations#w-3rd-street`,
          "telephone": "+12136001000",
          "email": "info@greenly.us",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "2542 W. 3rd Street",
            "addressLocality": "Los Angeles",
            "addressRegion": "CA",
            "postalCode": "90057",
            "addressCountry": "US"
          },
          "geo": { "@type": "GeoCoordinates", "latitude": 34.064, "longitude": -118.274 },
          "openingHoursSpecification": [
            { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "08:00", "closes": "17:00" },
            { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "09:00", "closes": "14:00" }
          ],
          "hasMap": "https://maps.google.com/?q=2542+W+3rd+Street+Los+Angeles+CA+90057",
          "areaServed": ["Downtown Los Angeles","Koreatown","Silver Lake","Echo Park","MacArthur Park","Mid-City","Westlake"],
          "priceRange": "Free"
        },
        {
          "@type": "LocalBusiness",
          "name": "Greenly Electronics Recycling — W Slauson Ave",
          "description": "Electronics recycling drop-off in South Los Angeles. TV recycling, computer recycling, battery recycling, hard drive destruction. CalRecycle CEWD-127531.",
          "url": `${(import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com')}/locations#w-slauson-ave`,
          "telephone": "+12136001000",
          "email": "info@greenly.us",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "4902 W. Slauson Ave",
            "addressLocality": "Los Angeles",
            "addressRegion": "CA",
            "postalCode": "90056",
            "addressCountry": "US"
          },
          "geo": { "@type": "GeoCoordinates", "latitude": 33.987, "longitude": -118.339 },
          "openingHoursSpecification": [
            { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "08:00", "closes": "17:00" },
            { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "09:00", "closes": "14:00" }
          ],
          "hasMap": "https://maps.google.com/?q=4902+W+Slauson+Ave+Los+Angeles+CA+90056",
          "areaServed": ["Ladera Heights","Baldwin Hills","Inglewood","Culver City","Crenshaw","View Park","Windsor Hills"],
          "priceRange": "Free"
        }
      ]
    })}</script>
    <Navbar />
    <main>
      {/* Hero */}
      <section className="bg-[#0F3D22] pt-28 pb-14 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb items={[{ label: 'Drop-Off Locations' }]} />
          <h1 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-3">
            Electronics Recycling Drop-Off Locations in Los Angeles
          </h1>
          <p className="text-green-200 max-w-2xl text-base leading-relaxed mb-5">
            Two convenient Los Angeles electronics recycling locations — <strong className="text-white">no appointment needed</strong>. Drop off your TVs, computers, batteries, and all electronics for free. Open Monday–Saturday.
          </p>
          <div className="flex flex-wrap gap-4">
            {[
              { icon: 'ri-map-pin-2-fill', text: '2 LA Locations' },
              { icon: 'ri-time-line', text: 'Mon–Fri 8am–5pm · Sat 9am–2pm' },
              { icon: 'ri-gift-line', text: 'Free Drop-Off' },
              { icon: 'ri-award-line', text: 'CalRecycle CEWD-127531' },
            ].map((b) => (
              <div key={b.text} className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 text-white text-xs font-semibold">
                <i className={`${b.icon} text-[#74C69D]`}></i>{b.text}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Both location cards */}
      <section className="py-16 bg-[#F4FAF7]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 space-y-12">
          {locations.map((loc, idx) => (
            <article
              key={loc.id}
              id={loc.id}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100"
            >
              <div className="flex flex-col lg:flex-row">
                {/* Info */}
                <div className="w-full lg:w-1/2 p-8 lg:p-10 flex flex-col justify-between">
                  <div>
                    {/* Location number badge */}
                    <div className="inline-flex items-center gap-2 bg-[#E8F5EE] text-[#1B6B3A] text-xs font-bold px-3 py-1.5 rounded-full mb-4">
                      <i className="ri-map-pin-2-fill"></i>
                      Location {idx + 1} — {loc.neighborhood}
                    </div>

                    <h2 className="text-xl md:text-2xl font-extrabold text-gray-900 mb-1">
                      {loc.address}
                    </h2>
                    <p className="text-gray-500 text-sm mb-5">{loc.city}, {loc.state} {loc.zip}</p>

                    {/* Dedicated page link */}
                    <Link
                      to={loc.id === 'w-3rd-street' ? '/locations/west-3rd-street' : '/locations/slauson-ave'}
                      className="inline-flex items-center gap-1.5 text-[#1B6B3A] font-bold text-xs hover:underline mb-4 cursor-pointer"
                    >
                      <i className="ri-arrow-right-line"></i>View Dedicated Page with Map & Directions
                    </Link>

                    {/* Hours */}
                    <div className="mb-6">
                      <div className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-3">Hours</div>
                      <div className="space-y-2">
                        {loc.hours.map((h) => (
                          <div key={h.days} className="flex items-center justify-between text-sm">
                            <span className="text-gray-600 font-medium">{h.days}</span>
                            <span className={`font-bold ${h.time === 'Closed' ? 'text-red-400' : 'text-[#1B6B3A]'}`}>{h.time}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Nearby areas */}
                    <div className="mb-6">
                      <div className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-3">Serving Nearby</div>
                      <div className="flex flex-wrap gap-2">
                        {loc.nearbyAreas.map((area) => (
                          <span key={area} className="bg-[#F4FAF7] text-[#1B6B3A] text-xs font-semibold px-3 py-1 rounded-full">
                            {area}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* CTAs */}
                  <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-gray-100">
                    <a
                      href={loc.mapLink}
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="flex-1 inline-flex items-center justify-center gap-2 bg-[#1B6B3A] hover:bg-[#2D8653] text-white font-bold px-5 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
                    >
                      <i className="ri-map-pin-line"></i>Get Directions
                    </a>
                    <a
                      href={loc.tel}
                      className="flex-1 inline-flex items-center justify-center gap-2 border border-gray-200 hover:border-[#1B6B3A] text-gray-700 hover:text-[#1B6B3A] font-semibold px-5 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
                    >
                      <i className="ri-phone-line"></i>{loc.phone}
                    </a>
                  </div>
                </div>
              </div>

              {/* Location photo */}
              <div className="border-t border-gray-100">
                <img
                  src={loc.image}
                  alt={`Electronics recycling drop-off at ${loc.address}, Los Angeles`}
                  className="w-full h-48 object-cover object-top"
                  loading="lazy"
                />
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* What to drop off */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <div className="text-[#1B6B3A] text-xs font-bold uppercase tracking-widest mb-2">What We Accept</div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900">
              What Can I Drop Off at Our Los Angeles Locations?
            </h2>
            <p className="text-gray-500 text-sm mt-2 max-w-xl mx-auto">
              We accept virtually all consumer and commercial electronics at both locations — for free, no appointment needed.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
            {[
              { icon: 'ri-tv-line', label: 'TVs & Monitors', path: '/tv-recycling' },
              { icon: 'ri-computer-line', label: 'Computers & Laptops', path: '/computer-recycling' },
              { icon: 'ri-battery-charge-line', label: 'All Batteries', path: '/battery-recycling' },
              { icon: 'ri-hard-drive-line', label: 'Hard Drives', path: '/hard-drive-destruction' },
              { icon: 'ri-smartphone-line', label: 'Phones & Tablets', path: '/services' },
              { icon: 'ri-printer-line', label: 'Printers & Fax', path: '/services' },
              { icon: 'ri-router-line', label: 'Network Equipment', path: '/services' },
              { icon: 'ri-keyboard-line', label: 'Keyboards & Mice', path: '/services' },
              { icon: 'ri-server-line', label: 'Servers & Drives', path: '/services' },
              { icon: 'ri-usb-line', label: 'Cables & Adapters', path: '/services' },
            ].map((item) => (
              <Link
                key={item.label}
                to={item.path}
                className="flex flex-col items-center gap-2 bg-[#F4FAF7] hover:bg-[#E8F5EE] border border-transparent hover:border-[#1B6B3A] rounded-xl p-4 text-center transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl">
                  <i className={`${item.icon} text-[#1B6B3A] text-lg`}></i>
                </div>
                <span className="text-xs font-bold text-gray-700">{item.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Services quick links */}
      <section className="py-10 bg-[#F4FAF7]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-lg font-extrabold text-gray-900 mb-5">Learn More About Each Recycling Service</h2>
          <div className="flex flex-wrap justify-center gap-3">
            {services.map((s) => (
              <Link key={s.path} to={s.path} className="flex items-center gap-2 bg-white border border-gray-200 hover:border-[#1B6B3A] text-gray-700 hover:text-[#1B6B3A] px-5 py-3 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap">
                <i className={s.icon}></i>{s.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 bg-[#1B6B3A]">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-4">
            Can't Make It to a Drop-Off Location?
          </h2>
          <p className="text-green-100 text-sm md:text-base mb-8 max-w-xl mx-auto">
            We offer free e-waste pickup for qualifying businesses throughout Los Angeles County. Call us or request service online.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a href="tel:+12136001000" className="inline-flex items-center justify-center gap-2 bg-white text-[#1B6B3A] font-bold px-8 py-3 rounded-md hover:bg-green-50 transition-colors cursor-pointer whitespace-nowrap text-sm">
              <i className="ri-phone-fill"></i>Call (213) 600-1000
            </a>
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 bg-white/20 border border-white/40 text-white font-semibold px-8 py-3 rounded-md hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap text-sm">
              <i className="ri-calendar-check-line"></i>Request Free Pickup
            </Link>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default LocationsPage;
